import React, { useEffect, useRef } from "react";

export default function DashboardCollapse(props) {

    const { className,
        id,
        activeDashboardCollapse } = props;

    const collapseEle = useRef(null);

    useEffect(() => {
        const $collapse = $(collapseEle.current);
        if ((activeDashboardCollapse && activeDashboardCollapse.substring(1) === $collapse.attr('id')) ||
            (activeDashboardCollapse == null && $collapse.hasClass('is-active'))) {
            $collapse.toggleClass('is-active').slideToggle();
        }
    });

    return (
        <div className={className} id={id} ref={collapseEle}>
            {props.children}
        </div>
    );
}